<template>
	<div id="app">
		<dv-full-screen-container style="background-color: black;">
			<dv-border-box-11 title="宜昌田家河" :title-width="400" style="height: 97vh;overflow: hidden;">
				<!-- <MySetting :visible.sync=showModel @save="handleSave" @del="delData" :marquee-text="marquee">
				</MySetting> -->
				<div class="main-layout">
					<div style="margin-top: 50px; height: 30px;width: 100%;">
						<div class="real-time">{{ currentTime }}</div>
						<!-- <div class="marquee">
							<span class="marquee_span" :key="marqueeKey"
								:style="{ animationDuration: marqueeDuration + 's' }">
								{{ marquee }}
							</span>
						</div>
						<div class="setting"><img @click="showModel = true" src="@/assets/setting.png" height="20px"
								width="20px" style="padding-right: 5px;" /></div> -->
					</div>
					<dv-scroll-board :config="data_config" class="scroll-board" />
				</div>
			</dv-border-box-11>
		</dv-full-screen-container>
	</div>
</template>

<style>
.dv-scroll-board .header .header-item {
	font-size: 18px !important;
	font-weight: 600;
}

.dv-scroll-board .rows .row-item {
	font-size: 18px !important;
}

#app {
	background: #00184a;
	color: #fff;
}

.main-layout {
	display: flex;
	flex-direction: column;
	height: 90%;
	padding: 20px;
}

.scroll-board {
	width: 100%;
	height: 250px;
	margin-top: 15px;
	border-radius: 6px;
	overflow: hidden;
}

.real-time {
	height: 100%;
	width: 15%;
	float: left;
	align-items: center;
	display: flex;
}

.marquee {
	height: 100%;
	width: 80%;
	float: left;
	color: yellow;
	font-size: 20px;
	white-space: nowrap;
	position: relative;
	overflow: hidden;
	text-align: center;
}

.setting {
	height: 100%;
	width: 5%;
	float: right;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.marquee_span {
	display: inline-block;
	padding-left: 100%;
	animation: marquee 20s linear infinite;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
}

@keyframes marquee {
	from {
		transform: translateX(0);
	}

	to {
		transform: translateX(-100%);
	}
}

@-webkit-keyframes marquee {
	from {
		transform: translateX(0);
	}

	to {
		transform: translateX(-100%);
	}
}
</style>
<script>
// import axios from 'axios';
// import MySetting from '@/components/MySetting.vue';
export default {
	components: {
		// MySetting
	},
	data() {
		return {
			marqueeDuration: 15, // 初始动画时长
			marqueeKey: 0, // 新增key控制
			showModel: false,
			marquee: '',

			minutes: '',
			seconds: '',
			data2: {
				"err": 0,
				"data": [],
			},
			timeConfig: {
				number: [new Date().getTime()],
				content: '{nt}',
				style: {
					fontSize: 36,
					fill: '#3de7c9',
					fontWeight: 'bold'
				}
			},
			data_source: [],
			total: 0,
			t1: 0, //未叫号
			t2: 0, //已叫号
			t3: 0, //已过号
			API_URL: `/myapi`,
			data_config: {
				header: ['司机姓名', '司机电话', '牵引车牌','货物名称','挂车车牌', '入场时间'],
				data: [

				],
				columnWidth: ['140', '140', '140', '240', '240', '240'],
				waitTime: 5000,
				index: true,
				rowNum: 10
			},
			weeks: ['日', '一', '二', '三', '四', '五', '六'],
			currentTime: '', // 当前时间字符串
			timeInterval: null, // 定时器引用
			fetchInterval: null, // 存储定时器ID
			notice_url: "/car/notice",
		}
	},
	created() {
		this.fetchData()
		// this.initData()
	},
	watch: {
		// marquee(newVal) {
		// 	if (newVal) {
		// 		// 根据内容长度计算动画时长（示例：每8字符增加1秒，最低15秒）
		// 		const minDuration = 15;
		// 		const maxDuration = 60;
		// 		const lengthFactor = Math.floor(newVal.length / 8);

		// 		// 动态调整时长（可根据需求修改公式）
		// 		this.marqueeDuration = Math.min(
		// 			maxDuration,
		// 			Math.max(minDuration, minDuration + lengthFactor)
		// 		);

		// 		// 强制重新渲染跑马灯（重置动画）
		// 		this.marqueeKey += 1;
		// 	}
		// }
	},
	methods: {
		handleSave(newContent) {
			this.marqueeKey += 1; // 强制重新创建span元素
			this.marquee = newContent;

			try {
				fetch(this.notice_url, {
					method: 'PUT',
					headers: {
						"content-type": "application/x-www-form-urlencoded"
					},
					body: "notice=" + this.marquee
				});
			} catch (error) {
				console.error('请求失败:', error);
			}
		},
		delData() {
			this.marquee = '';
			try {
				fetch(this.notice_url, {
					method: 'DELETE'
				});
			} catch (error) {
				console.error('请求失败:', error);
			}
		},
		async fetchData() {

			this.data_config.data = []

			const url = `/myapi/api/yq_datav/test?page=1&limit=9999`;
			try {
				const response = await fetch(url);

				// 判断 HTTP 请求是否成功（状态码 200-299）
				if (!response.ok) {
					throw new Error(`HTTP 错误! 状态码: ${response.status}`);
				}

				// 解析 JSON 数据
				const data = await response.json();

				// 判断业务逻辑是否成功（假设接口返回 { err: 0 表示成功 }）
				if (data.code === 1) {
					
					this.data2.data = data.data.data
					
				} 


				// 处理数据并生成新的表格数据
				const newData = this.data2.data
					.map(item => [
						item.driverName,
						item.driver_tel,
						item.tow_license, 
						item.sale_product,
						item.mount_license,
						item.inTime_text
					])
				// 创建新配置对象
				const newConfig = {
					...this.data_config, // 保留原有配置
					data: newData, // 更新数据
					columnWidth: ['140', '240', '240', '240', '290', '290', '290', '240'],
					waitTime: 2000,
					index: true,
					hoverPause: false,
					rowNum: 10
				};

				// 触发响应式更新
				this.data_config = {
					...newConfig
				};
			} catch (error) {
				console.error('请求失败:', error);
			}



		},
		async initData() {
			try {
				const response = await fetch(this.notice_url);

				// 判断 HTTP 请求是否成功（状态码 200-299）
				if (!response.ok) {
					throw new Error(`HTTP 错误! 状态码: ${response.status}`);
				}

				// 解析 JSON 数据
				const data = await response.json();

				// 判断业务逻辑是否成功（假设接口返回 { err: 0 表示成功 }）
				if (data.code === 200) {
					this.marquee = data.data
				}
			} catch (error) {
				console.error('请求失败:', error);
			}

		},
		updateTime() {
			// 获取当前时间
			const now = new Date()
			// 格式化时间字符串
			this.currentTime = '星期' + this.weeks[now.getDay()] + '  ' + now.getFullYear() + '-' + String(now
				.getMonth() + 1)
				.padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0') + ' ' + String(now.getHours())
					.padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0') + ':' + String(now.getSeconds())
						.padStart(2, '0')
			this.minutes = String(now.getMinutes()).padStart(2, '0')
			this.seconds = String(now.getSeconds()).padStart(2, '0')
		}
	},
	mounted() {
		// 初始化时间显示
		this.updateTime()
		// 启动定时器
		this.timeInterval = setInterval(() => {
			this.updateTime()
		}, 1000);
		setInterval(() => {
			this.timeConfig.number = [new Date().getTime()];
		}, 1000);


		this.fetchInterval = setInterval(() => {
			if (this.minutes % 2 == 0 & this.seconds == 0) {
				this.fetchData()
			}
		}, 1000)

		// this.initInterval = setInterval(() => {
		// 	this.initData()
		// }, 60000)

	},
	beforeDestroy() {
		// 清理定时器
		clearInterval(this.timeInterval)
		clearInterval(this.fetchInterval)
		clearInterval(this.initInterval)
	},
}
</script>